import { Stack } from 'expo-router';

export default function DataSourcesLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false
      }}
    >
      <Stack.Screen name={'index'} />
    </Stack>
  );
}
